// lib/features/theme/themeSlice.js
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    mode: 'light',
    preference: 'system',
}

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        toggleTheme(state) {
            state.mode = state.mode === 'light' ? 'dark' : 'light'
            state.preference = state.mode
        },
        setTheme(state, action) {
            if (typeof action.payload === 'string') {
                state.mode = action.payload
                state.preference = action.payload
                return
            }

            state.mode = action.payload.mode
            state.preference = action.payload.preference ?? state.preference
        },
    },
})

export const { toggleTheme, setTheme } = themeSlice.actions
export default themeSlice.reducer
